<script>
import BaseModal from 'dashboard/components/dahreply/BaseModal.vue';
import { mapActions } from 'vuex';
import { useAlert } from 'dashboard/composables';

export default {
  name: 'ToggleModal',
  components: {
    BaseModal
  },
  props: {
    service: {
      type: Object,
      required: true
    },
    isGlobal: {
      type: Boolean,
      default: true,
    },
    branchId: {
      type: String,
    }
  },
  data() {
    return {
      name: '',
      errors: {},
      isLoading: false
    };
  },
  computed: {
    isActive() {
      if(this.isGlobal) {
        return this.service.service.is_active;
      } else {
        return this.service.assignment.is_enabled;
      }
    }
  },
  methods: {
    ...mapActions('serviceV2', ['toggleService']),
    async handleConfirm() {
      this.errors = {};

      // Validation only when disabling
      if (this.isGlobal) {
        // Disabling global service requires reason
        if (this.service.service.is_active && !this.name.trim()) {
          this.errors.name = 'Reason is required when disabling a service.';
          return;
        }
      } else {
        // Disabling *branch* service requires reason
        if (this.service.assignment.is_enabled && !this.name.trim()) {
          this.errors.name = 'Reason is required when disabling a service in this branch.';
          return;
        }
      }

      this.isLoading = true;

      try {
        if(this.isGlobal) {
          const payload = {
            serviceId: this.service.service.id,
            disabled_reason: this.service.service.is_active ? this.name : '',
            isActive: !this.service.service.is_active
          };

          useAlert(
            this.service.service.is_active
              ? 'Service disabled successfully globally.'
              : 'Service enabled successfully globally.'
          );

          await this.toggleService(payload);
        } else {
          const payload = {
            branch_id: this.branchId,
            service_id: this.service.service.id,
            is_enabled: !this.service.assignment.is_enabled,
            disabled_reason: this.service.assignment.is_enabled ? this.name : '',
          }

          useAlert(
            this.service.assignment.is_enabled
              ? 'Service disabled successfully in branch.'
              : 'Service enabled successfully in branch.'
          );

          await this.$store.dispatch('branchServices/updateBranchServiceStatus', payload);
        }

        this.$emit('close');
        this.$emit('refresh');
      } catch (error) {
        console.error(error);
        useAlert(
          error.message || 'Failed to toggle service status.'
        );
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>

<template>
  <BaseModal @close="$emit('close')">
    <template #title>Toggle Service</template>

    <form
      v-if="isActive"
      @submit.prevent="handleConfirm"
      class="space-y-5"
    >
      <!-- Disable Reason -->
      <div>
        <label class="label">
          Disable reason <span class="text-red-500">*</span>
        </label>
        <input
          v-model="name"
          type="text"
          placeholder="Enter disable reason"
          class="input"
        />
        <p v-if="errors.name" class="text-red-500">{{ errors.name }}</p>
      </div>
    </form>

    <p v-else>
      Enable <span class="font-bold">{{ service.service.name }}</span>?
    </p>

    <template #footer>
      <div class="flex justify-end gap-3 mt-4">
        <woot-button
          color-scheme="secondary"
          @click="$emit('close')"
          :disabled="isLoading"
        >
          Cancel
        </woot-button>
        <woot-button
          @click="handleConfirm"
          :loading="isLoading"
          :disabled="isLoading"
        >
          Confirm
        </woot-button>
      </div>
    </template>
  </BaseModal>
</template>
